import type { SnapshotSpell } from '../../core/run';
import { queueTouchSpell } from '../touchSpells';

const SLOTS = 4;

export function SpellBar({ spells }: { spells: SnapshotSpell[] }) {
  return (
    <div class="spell-bar" aria-label="Sorts">
      {Array.from({ length: SLOTS }, (_, i) => {
        const s = spells[i];
        if (!s) return <div key={i} class="spell-slot empty"><span class="spell-key">{i + 1}</span></div>;
        return (
          <div key={i} class="spell-slot" onPointerDown={(e) => { if (e.pointerType === 'touch') { e.preventDefault(); queueTouchSpell(i); } }}>
            <img src={`/assets/${s.icon}.png`} alt={s.name} title={`${s.name} (niv. ${s.level})`} />
            <div class="spell-cd" style={{ height: `${s.cooldownMax ? Math.min(100, (s.cooldown / s.cooldownMax) * 100) : 0}%` }} />
            <span class="spell-key">{i + 1}</span>
          </div>
        );
      })}
    </div>
  );
}
